var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -10 90 70",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    style: {
      color: "#6AB9FF"
    },
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 10,
    height: 50
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "50;10;50",
    begin: "0s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "0;20;0",
    begin: "0s",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 0,
    width: 10,
    height: 50
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "50;10;50",
    begin: "0.2s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "0;20;0",
    begin: "0.2s",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 0,
    width: 10,
    height: 50
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "50;10;50",
    begin: "0.4s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "0;20;0",
    begin: "0.4s",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 0,
    width: 10,
    height: 50
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "50;10;50",
    begin: "0.6s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "0;20;0",
    begin: "0.6s",
    dur: "1s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.1e681d15b0a953c7f4a0b05b138fcfba.svg";
export { ForwardRef as ReactComponent };